export const pageTitle = (title) => {
  return ( document.title = title + " - Design Deploy Scale");
}